import React, { Component } from 'react';
import feathers from '../../feathers';
class OperatorsName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operator: {}
    };
  }

  async componentWillMount() {
    let operator = await feathers.service('operators').get(
      this.props.id
      
    );

    this.setState({
      operator: operator
    });
  }

  async componentWillReceiveProps (nextProps){
    if(nextProps){
      let operator = await feathers.service('operators').get(
        nextProps.id
      );
  
      this.setState({
        operator: operator
      });
    }
  }

  render() {
    let { operator } = this.state;

    return (
      <div>
        <span>{operator.name}</span>
      </div>
    );
  }
}

export default OperatorsName;



// WEBPACK FOOTER //
// ./src/components/OperatorsName/OperatorsName.jsx